import { useModelService } from 'services/model/model.service';
import { measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function usePerformanceDashboardKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const measures = getMeasures([
    'ordGmvVal',
    'slsGmvValOD',
    'netSlsGmvValExpOD',
    'netSlsGmvValExtExpOD',
    'ordNum',
    'avgOrdGmvVal',
    'retQtyRateExpOD',
    'retGmvValExpOD',
  ]);

  return measures.map(measure => measureKpi(measure));
}

export function PerformanceDashboardInfoContent() {
  const kpis = usePerformanceDashboardKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="insights.performance_tab.info.content.why_is_this_view_useful_description"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
